import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/search/facetmenu.scss';

class FacetMenu extends Component {
  makeBackArrow() {
    const { hydraNewSearchNav, facets: { chosenFacetGroup }, clearChosenFacet } = this.props;
    const { testId } = this.context;
    return !hydraNewSearchNav && chosenFacetGroup
      ? <button
        type="button"
        className={css.facetBack}
        onClick={clearChosenFacet}
        data-test-id={testId('facetBack')}
        aria-label="back to categories">
        <span className={css.arrow}/>
      </button>
      : '';
  }

  makeMenuTitle() {
    const { hydraNewSearchNav, hasMobileLayeredFacets, mobileFacetHeader, facets: { chosenFacetGroup }, totalProductCount } = this.props;

    if (hydraNewSearchNav) {
      return (
        <div>
          <h3>{mobileFacetHeader}</h3><p className={css.productCount}>{totalProductCount} items</p>
        </div>
      );
    }

    return (
      <div>
        <span className={cn({ [css.nonLayerdFacets]: !hasMobileLayeredFacets })}>
          <h3>{hasMobileLayeredFacets && chosenFacetGroup ? chosenFacetGroup.facetFieldDisplayName : mobileFacetHeader}</h3>
        </span>
        {hasMobileLayeredFacets && <div className={css.productCount}>{totalProductCount} items</div>}
      </div>
    );
  }

  render() {
    const { hasMobileLayeredFacets } = this.props;
    return (
      <div className={`${css.facetMenu} ${css.fixed}`}>
        {hasMobileLayeredFacets && this.makeBackArrow()} {this.makeMenuTitle()}
      </div>
    );
  }
}

FacetMenu.displayName = 'FacetMenu';
FacetMenu.contextTypes = {
  testId: PropTypes.func
};

export default withErrorBoundary('FacetMenu', FacetMenu);
